/**
 * The cap unit, and its tooltip, by role — `04-officials-profiles.md` §A3.
 *
 * > *"Cap counts come from TMS and the unit differs by role — for Technical Officers and
 * > Judges it is the number of matches officiated at the technical table; for Umpires it is
 * > the number of matches umpired; and for Umpires Managers it is the number of tournaments
 * > served as UM, not matches."*
 *
 * It lives in its own module because two surfaces print the same figure — the roster row and
 * the profile's identity header — and the same discipline §A3 states of the report-status
 * map applies here: **one shared derived value, not two copies.** A UM cap of 18 must not
 * read as tournaments on one screen and matches on the other.
 */

import type { CapUnit, OfficialRole } from "@hockeytd/shared";

/** The short unit printed beside the figure. */
export const CAP_UNIT_SHORT: Readonly<Record<CapUnit, string>> = {
  matches: "Matches",
  tournaments: "Tourns",
};

/** The tooltip §A3 gives the figure, which is where the unit is spelled out in full. */
export function capTooltip(role: OfficialRole): string {
  if (role === "UM") return "Tournaments Served As Umpires Manager";
  if (role === "Umpire") return "Matches Umpired";
  return "Matches Officiated At The Technical Table";
}
